import * as types from './mutations'
import layouts from '@/views/layouts'

const defaultLayout = 'layout-default'

const state =
{
    loading: true,
    isMobile: true,
    title: '',
    desc: '',
    siteImage: '',
    url: '',
    layout: null,
    layoutName: defaultLayout,
    backdrop: false,
    keywords: '',
}

const mutations =
{
    [types.UPDATE_LOADING] (state, loading)
    {
        state.loading = loading
        if (state.loading)
            document.body.classList.add('loading')
        else
            document.body.classList.remove('loading')
    },

    [types.SET_LAYOUT] (state, layout)
    {
        state.layoutName = layout
        state.layout = !layout || !layouts[layout] ? layouts[defaultLayout] : layouts[layout]
    },

    [types.UPDATE_TITLE] (state, title)
    {
        state.title = title
    },

    [types.UPDATE_DESC] (state, desc)
    {
        state.desc = desc
    },

    [types.UPDATE_SITE_IMAGE] (state, url)
    {
        state.siteImage = url
    },

    [types.UPDATE_SITE_URL] (state, url)
    {
        state.url = url
    },

    [types.UPDATE_BACKDROP] (state, backdrop)
    {
        if (backdrop)
        {
            document.getElementsByTagName('body')[0].classList.add('backdrop')
        } else {
            document.getElementsByTagName('body')[0].classList.remove('backdrop')
        }
        state.backdrop = backdrop
    },

    [types.UPDATE_ISMOBILE] (state, isMobile)
    {
        state.isMobile = isMobile
    },

    [types.UPDATE_KEYWORDS] (state, keywords)
    {
        state.keywords = keywords
    },
}

const actions =
{
    init()
    {
        return new Promise(async(resolve, reject) =>{
            try {
                // .. fetch important data before loading here
                resolve()
            } catch (e) {
                reject()
            }
        })
    },

    updateLoading({commit}, state)
    {
        return new Promise(async(resolve) => {
            setTimeout(() => {
                commit(types.UPDATE_LOADING, state)
                resolve()
            }, 64)
        })
    },

    setLayout({commit, state}, layout)
    {
        if (state.layoutName !== layout)
            commit(types.SET_LAYOUT, layout)
    },

    updateTitle({commit}, title)
    {
        commit(types.UPDATE_TITLE, title)
    },

    updateDesc({commit}, desc)
    {
        commit(types.UPDATE_DESC, desc)
    },

    updateSiteImage({commit}, url)
    {
        commit(types.UPDATE_SITE_IMAGE, url)
    },

    updateSiteUrl({commit}, url)
    {
        commit(types.UPDATE_SITE_URL, url)
    },

    updateKeywords({commit}, keywords)
    {
        commit(types.UPDATE_KEYWORDS, keywords)
    },

    isMobile({commit}, state)
    {
        commit(types.UPDATE_ISMOBILE, state)
    },

    backdrop({commit}, state)
    {
        commit(types.UPDATE_BACKDROP, state)
    },

    backdropClose({commit})
    {
        commit(types.UPDATE_BACKDROP, false)
    },
}

const getters = 
{
    isLoading: state => state.loading === true,
    isMobile: state => state.isMobile,
    siteLayout: state => state.layout,
    siteTitle: state => state.title,
    siteDesc: state => state.desc,
    backdrop: state => state.backdrop,
    layoutName: state => state.layoutName,
    siteImage: state => state.siteImage,
    siteUrl: state => state.url,
    keywords: state => state.keywords,
}

export default {
    state,
    mutations,
    actions,
    getters,
}
